<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Spacing table (preserved from AngularJS) -->
<table [hidden]="minimise">
  <tr>
    <td>&nbsp;</td>
  </tr>
</table>

<!-- Entity information table (CRITICAL: Standard field order) -->
<div class="table-scroll-entity" [hidden]="minimise">
  <table class="table table-bordered form-inline enityDetails custom-table">
    <tr>
      @for (item of entityList; track $index) {
<td>
        <span><strong>{{ item.key }}</strong></span>
      </td>
}
    </tr>
    <tr>
      @for (item of entityList; track $index) {
<td>
        <span>{{ item.value }}</span>
      </td>
}
    </tr>
  </table>
</div>

<!-- Body with form data -->
<div class="modal-body" [hidden]="minimise">
  <!-- Table header - Fixed position -->
  <div class="table-scroll-head">
    <table class="table table-no-bottom-margin table-bordered">
      <tr>
        <th colspan="2">Partners' Distributive Share Items</th>
        <th style="width:196px">Amount</th>
      </tr>
    </table>
  </div>

  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  <!-- Scrollable content area -->
  @if (!showFormLoader) {
<div class="slim-scroll-block">
    @if (F8865SchdKWPDDetailForEntity && F8865SchdKWPDDetailForEntity.length === 0) {
<div style="padding: 20px; text-align: center; color: #666;">
      No data available to display
    </div>
}
    
    @if (F8865SchdKWPDDetailForEntity && F8865SchdKWPDDetailForEntity.length > 0) {
<table class="table table-bordered table-no-top-margin form-inline custom-table">
      @for (row of F8865SchdKWPDDetailForEntity; track trackByFn($index, row)) {
<tr>
        <td style="width:3%">{{row.LINE_NO}}</td>
        <td style="width:87%">{{row.LINE_DESCRIPTION}}</td>
        <td style="width:10%">
          <input 
            [ngModel]="row.ADJ_AMT_1" 
            (ngModelChange)="row.ADJ_AMT_1 = $event; setChange(row)" 
            type="number" 
            step="0.01"
            class="form-control input-sm numText" 
            style="text-align: right;" />
        </td>
      </tr>
}
    </table>
}
  </div>
}
</div>

<!-- Footer for modal with standardized buttons -->
<div class="modal-footer" [hidden]="minimise">
  @if (showSaveButton) {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
